import(/* webpackMode: "eager", webpackExports: ["ServicePage"] */ "/vercel/path0/src/app/(pages)/(services)/brand-and-design/service.tsx");
